export { default as LOGO_EN } from "./logo-en.png";
